export default __webpack_public_path__ + "static/media/product-1.bd5f9566.png";